<template>
  <div class="card" ref="card">
    <div class="placeName">
      {{ data.name }}
    </div>
    <div class="summary">
      <span>该点存在</span>
      <span v-if="data.riskGroups || data.riskGroups.length !== 0">
        <span v-for="(item,index) in data.riskGroups" :key="index">
          {{ item.name }}
        </span>
      </span>
      <span v-if="data.riskDevices || data.riskDevices.length !== 0">
            <span v-for="riskDevice in data.riskDevices" :key="riskDevice.id">
              {{ riskDevice.summary }},
            </span>
          </span>
    </div>

    <div class="manual-analysis" v-if="data.manualAnalysisRecord && data.manualAnalysisRecord.content">
      <div class="manual-analysis-content">{{ data.manualAnalysisRecord.content }}</div>
    </div>

    <div class="card-calendar" v-show="isMap">
      <DataTimeLine :timeline-data = "dataTimeList"></DataTimeLine>
    </div>

    <div class="card-content" v-if="charts && data.inspections.length === 0">
      <SeChart v-for="(item, index) in charts"
                :key = "data.id + index"
                :chart-id="data.id + index"
                :description="item.chartTitle"
                :title="item.seriesTitle"
                :data="item.seriesData">
      </SeChart>
    </div>
    <div class="card-content" v-for="item in data.inspections" :key="item.id" v-show="isVisible">
      <div>
        <div>
          <span style="line-height: 26px">排查情况：{{ item.issueDescription }}</span>
        </div>
      </div>
      <div v-if="!item.issueUrl || item.issueUrl.length === 0">暂无图片</div>
      <div v-else class="img">
        <el-image
          v-for="(url,idx) in item.issueUrl"
          :key="idx"
          :src="url"
          :preview-src-list="item.issueUrl"
          :initial-index="idx"
          style="width: 200px; height: 200px; border-radius: 5px; cursor: pointer;"
          fit="cover"
          lazy
          :preview-teleported="true"
          hide-on-click-modal>
          <template #error>
            <div>图片加载失败</div>
          </template>
        </el-image>
      </div>
    </div>
  </div>
</template>

<script>
import instantData from "@/scripts/instantData";
import SeChart from "components/se-chart.vue";
import DataTimeLine from "components/DataTimeLine.vue";
export default {
  name: "card",
  components: { DataTimeLine, SeChart },
  data() {
    return {
      isVisible: false,
      observer: null,
      charts: [],
      dataTimeList: [],
      isMap: true,
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    index: {
      type: Number,
      default: 0
    },
    startTime:{
      type: String,
      default: ''
    },
    endTime:{
      type: String,
      default: ''
    }
  },
  mounted() {
    this.createObserver()
    this.getCalendarDate()
    this.getTimeLineData()
  },
  beforeDestroy() {
    this.clearObserver()
  },
  methods: {
    // 创建交叉观察器
    createObserver() {
      // 创建交叉观察器
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            // 一旦可见，停止观察
            if (this.observer) {
              this.observer.unobserve(this.$refs.card);
              this.observer = null;
              // 加载数据
              this.loadData();
            }
          }
        });
      }, {
        rootMargin: '50px' // 提前50px加载
      });

      // 开始观察
      this.$nextTick(() => {
        if (this.observer) {
          this.observer.observe(this.$refs.card);
        }
      });
    },
    // 清除观察器
    clearObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },
    loadData() {
      this.getInstantData()
    },

    // 根据data中的参数访问接口获取对应的图表数据
    getInstantData() {
      const that = this
      const monitorSiteId = this.data.id;
      const chartParam = this.data.chartParam;
      if (!monitorSiteId || !chartParam) {
        return;
      }
      const titleList = chartParam.tableTitle;
      const paramsList = chartParam.paramsList;
      if (!paramsList) {
        return;
      }
      const title = titleList[0];
      const params = paramsList[0];
      const p = instantData.getChartData(monitorSiteId, params, chartParam.startTime, chartParam.endTime)
      p.then(res => {
        if (!res.data || res.data.length === 0) {
          return
        }
        const seriesTitle = res.data[0];
        const seriesData = res.data.slice(1);
        that.charts.push({chartTitle: title, seriesTitle: seriesTitle, seriesData: seriesData})
      })
    },
    getCalendarDate() {
      const monitorSiteId = this.data.id;
      const c = instantData.getCalendarDate(monitorSiteId, this.startTime, this.endTime)
      c.then(res => {
        return res
      })
    },
    getTimeLineData(){
      const monitorSiteId = this.data.id;
      const t = instantData.getTimeLineData(monitorSiteId, this.startTime, this.endTime)
      t.then(res => {
        this.dataTimeList = res.data;
      })
    }
  }
}
</script>

<style scoped lang="less">
.card{
  flex: 1;
  font-size: 16px;
  width: 100%;
  min-width: 0;
  padding: 20px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  border: 1px solid #EBEEF5;
}

.placeName{
  font-size: 20px;
}

.summary{
  margin-top: 10px;
  color: #7D879F;
}

.manual-analysis{
  margin-top: 10px;
  padding: 10px;
  background-color: #F5F7FA;
  border-radius: 4px;
}

.manual-analysis-title{
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
}

.manual-analysis-content{
  color: #606266;
  line-height: 1.5;
}

.card-calendar{
  padding: 10px;
}

.card-content{
  margin-top: 20px;
  height: 300px;
  min-height: 300px;
}

.img {
  margin-top: 10px;
  display: flex;
  gap: 20px;
}
</style>
